import { useRef } from 'react'
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
} from '@chakra-ui/react'
import { useUnsavedChangesStore } from '@/store/unsavedChanges'

/** Global leave confirmation when a form has registered dirty state. */
export function UnsavedChangesLeaveDialog() {
  const isDialogOpen = useUnsavedChangesStore((s) => s.isDialogOpen)
  const message = useUnsavedChangesStore((s) => s.message)
  const confirmLeave = useUnsavedChangesStore((s) => s.confirmLeave)
  const cancelLeave = useUnsavedChangesStore((s) => s.cancelLeave)
  const cancelRef = useRef<HTMLButtonElement>(null)

  return (
    <AlertDialog
      isOpen={isDialogOpen}
      leastDestructiveRef={cancelRef}
      onClose={cancelLeave}
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            Unsaved changes
          </AlertDialogHeader>
          <AlertDialogBody>{message}</AlertDialogBody>
          <AlertDialogFooter>
            <Button ref={cancelRef} onClick={cancelLeave}>
              Stay
            </Button>
            <Button colorScheme="red" onClick={confirmLeave} ml={3}>
              Leave
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  )
}
